/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_ods9jpAIR",
    "aws_user_pools_web_client_id": "7jdh37dljq5oehhn47l56r2m98",
    "oauth": {}
};


export default awsmobile;
